import { combineReducers } from "redux";

import { default as update } from "./update";
import { default as reset } from "./reset";
export * from "./update";
export * from "./reset";

export default combineReducers({ reset, update });
